import * as _ from 'lodash';
import {Injectable} from "@angular/core";

@Injectable()
export class DivisionsProvider {
    divisions = [
        {code: 1, label: 'Omnik'}
    ]

    find(divisionCode) {
        const division = this.divisions.filter(division => division.code == divisionCode);

        if (_.isEmpty(division))
            throw 'Divisão inválida';

        return division;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/providers/enums/divisions.provider.ts